<template>
  <default-layout>
    <event-navbar title="Kontakte" />
    <div class="container-fluid">
      <contact-list></contact-list>
    </div>
  </default-layout>
</template>

<script>
// @ is an alias to /src
import ContactList from '@/components/speaker/contact-list.vue'
import EventNavbar from '@/components/EventNavbar.vue'
import DefaultLayout from '@/components/DefaultLayout.vue'

export default {
  name: 'ContactListView',
  components: {
    ContactList, EventNavbar, DefaultLayout
  },
}
</script>
